import { memo } from 'react'

import { DomainOutlined, PeopleOutlineOutlined, PublicOutlined, SettingsOutlined } from '@mui/icons-material'

import { Chip, ChipProps } from '@collaborate-health/uikit'

import { AnnouncementScope, AnnouncementScopeDisplayName } from '../../enums'

const AnnouncementScopeToColorMap: Record<AnnouncementScope, ChipProps['color']> = {
  [AnnouncementScope.System]: 'error',
  [AnnouncementScope.Corporation]: 'success',
  [AnnouncementScope.Tenant]: 'primary',
}

const AnnouncementScopeToIconMap: Record<AnnouncementScope, ChipProps['icon']> = {
  [AnnouncementScope.System]: <PublicOutlined />,
  [AnnouncementScope.Corporation]: <DomainOutlined />,
  [AnnouncementScope.Tenant]: <PeopleOutlineOutlined />,
}

export interface AnnouncementScopeChipProps {
  scope: AnnouncementScope
  onChange?: (scope: AnnouncementScope) => void
}

const AnnouncementScopeChip: React.FC<AnnouncementScopeChipProps> = ({ scope, onChange }) => {
  return (
    <Chip
      size='small'
      icon={AnnouncementScopeToIconMap[scope]}
      color={AnnouncementScopeToColorMap[scope]}
      label={AnnouncementScopeDisplayName[scope]}
      deleteIcon={onChange && <SettingsOutlined />}
      onDelete={onChange}
    />
  )
}

export default memo(AnnouncementScopeChip)

